import React, {Component} from 'react'
import AmCharts from "@amcharts/amcharts3-react";

class LineChart extends Component {

    constructor(props) {
        super(props);
        // this.state = {
        //     dataProvider: generateData(),
        //     timer: null
        // };
    }

    componentDidMount() {
        // this.setState({
        //     // Update the chart dataProvider every 3 seconds
        //     timer: setInterval(() => {
        //         this.setState({
        //             dataProvider: generateData()
        //         });
        //     }, 40000)
        // });
        // console.log(this.state.dataProvider);

    }
    componentWillUnmount() {
        // clearInterval(this.state.timer);
    }
    handleClick(e){
        console.log(e);
    }
    render() {   //console.log(this.props.data);
        var graphs = [];
        var valueAxes = [];
        var l =1;
        var fileName = ''
        if(this.props.name===null || this.props.name==='null' || this.props.name===undefined || this.props.name==='undefined') {
          fileName = "chartData"
        }
        fileName = this.props.name;
        var pos = "left";
        // singleAxis=true: every line shares one left-hand axis (used for charts with several
        // series - e.g. one line per tender mode - where a separate axis per line just clutters
        // both sides with overlapping labels). Defaults to false so existing charts that rely on
        // per-series axes (e.g. two series with different scales) keep their old behavior.
        var useSingleAxis = this.props.singleAxis === true;
        this.props.y_axis.map(function (pl, index) {
            if(!useSingleAxis && l>1) { pos = "right"; }
            graphs.push({
                "valueAxis": useSingleAxis ? "v1" : "v"+l,
                "bullet": "round",
                "bulletBorderAlpha": 1,
                "bulletColor": "#FFFFFF",
                "bulletSize": 3,
                // "balloon": {
                //     "enabled": true,
                //     "horizontalPadding":2
                // },
                "hideBulletsCount": 50,
                "lineThickness": 2,
                "balloonText": "<span style='font-size:9px; color:#000000;'>[[title]]: [[value]]</br>[[lableText]]</span>",
                "title": pl,
                "useLineColorForBulletBorder": true,
                "valueField": pl,

            });
            if (!useSingleAxis) {
                valueAxes.push({
                    "id":"v"+l,
                    "axisThickness": 2,
                    "position": pos,
                    "axisColor": "#E3E3E3",
                    "title": pl,
                    "axisAlpha": 1,
                    // "titleBold": false,
                    "titleColor": "#333333",
                    "titleFontSize": 11
                })
            }
            l++;
        })
        if(useSingleAxis || this.props.name=='Transaction Amount by Payment Type - Non EFT'){
            valueAxes = [];
            valueAxes.push({
                "id":"v1",
                "axisThickness": 2,
                "position": "left",
                "axisColor": "#E3E3E3",
                "title": "",
                "axisAlpha": 1,
                // "titleBold": false,
                "titleColor": "#333333",
                "titleFontSize": 11
            })
        }
        const config = {
            "type": "serial",
            "theme": "light",
            "legend": {
                "useGraphSettings": true,
                // "verticalGap":4,
                "valueFunction": function(graphDataItem, valueText) {
                    return "";
                 },
                "align": "center",
                "autoMargins": false,
                "equalWidths": false,
                "valueAlign": "left",
                "valueWidth": 10,
                "fontSize":8,
                "marginLeft":0,
                "marginRight":0,
                "marginTop":0,
                "marginBottom":0,
                "verticalGap":5

            },
            "marginTop": 5,
            "marginRight": 10,
            "marginLeft": 20,
            "autoMarginOffset": 20,
            "mouseWheelZoomEnabled": true,
            "dataProvider": this.props.data,
            "synchronizeGrid":true,
            "valueAxes": valueAxes,
            "graphs": graphs,
            "chartScrollbar": {
                "enabled":false,
                "graph": "g1",
                "autoHide": true,
                "oppositeAxis": false,
                "offset":30,
                "scrollbarHeight": 80,
                "backgroundAlpha": 0,
                "selectedBackgroundAlpha": 0.1,
                "selectedBackgroundColor": "#888888",
                "graphFillAlpha": 0,
                "graphLineAlpha": 0.5,
                "selectedGraphFillAlpha": 0,
                "selectedGraphLineAlpha": 1,
                "autoGridCount": true,
                "color":"#AAAAAA"
            },
            "chartCursor": {
                "pan": true,
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true,
                "cursorAlpha":1,
                "cursorColor":"#258cbb",
                "limitToGraph":"g1",
                "valueLineAlpha":0.2,
                "valueZoomable": true,
                "zoomable": true
            },
            "valueScrollbar":{
                "enabled" :false,
                "oppositeAxis": false,
                "offset":50,
                "scrollbarHeight":10
            },
            "categoryField": this.props.x_axis,
            "categoryAxis": {
                "dashLength": 1,
                "minorGridEnabled": false,
                "labelRotation": 25,
                "fontSize":8,
            },
            "export": {
                "enabled": true,
                "fileName": fileName.replace(/ /g,"_"),
                "menu": [ {
                "class": "export-main",
                "menu": ["XLSX", "CSV" ],
              } ]
            },
            listeners:[{
                    "event": "clickGraphItem",
                    "method": (e)=>{this.handleClick(e.item)}
                }]
    };
        return (
            <div className ="chart_div">
                <AmCharts.React style={{ width: "100%", height: this.props.chartHeight }} options={config} />
            </div>
        );
    }
}

export default LineChart;